import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { AppTheme, AppStyles } from '../styles/AppTheme';
import { ButtonComponent } from '../components/quizzing/ButtonComponent';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Icon from '@material-ui/core/Icon';
import { Controller } from '../common/Controller';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import { CommonStyles } from '../styles/Styles';
import { AppConfig } from '../AppConfig';

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div className={css(Styles.iconContainer)} onClick={onClick} >
      <Icon className={css(Styles.iconContent)} color='secondary'>
        {props.currentSlide !== 0 ? 'arrow_back' : undefined}
      </Icon>
    </div>
  );
}

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div className={css(Styles.iconContainer)} onClick={onClick} >
      <Icon className={css(Styles.iconContent)} color='secondary'>
        {props.currentSlide !== props.slideCount - 1 ? 'arrow_forward' : undefined}
      </Icon>
    </div>
  );
}

const settingSlider = {
  dots: true,
  infinite: false,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  dotsClass: 'slick-dots',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: true,
      }
    },
    {
      breakpoint: 769,
      settings: {
        arrows: true,
      }
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
      }
    }
  ],
  appendDots: dots => (
    <div style={{ bottom: 5 }}>
      <ul className={css(Styles.dotContent)}>{dots}</ul>
    </div>
  )
};


export class Introduction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchState: ApiHelper.State.LOADING,
      items: []
    }
  }

  componentDidMount() {
    this.fetchItems()
  }

  fetchItems() {
    ApiHelper.call(
      { authWithKey: true, method: 'GET', endPoint: ApiHelper.makeUrlPath(['items'], { groupId: 'intro' }) },
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        if(!result || !result.items) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
        }

        const items = result.items.sort((a, b) => Number(a.order) - Number(b.order))
        this.setState({
          fetchState: ApiHelper.State.READY,
          items: items
        })
      }.bind(this))
  }

  getHomeLink = () => {
    if (Controller.get().loginMgr().getCurrentUser()) {
      return ({
        pathname: AppConfig.clientDashboard,
      })
    } else {
      return ({
        pathname: '/login',
        search: (this.props.location && this.props.location.search) ? this.props.location.search : ''
      })
    }
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView() {
    return (
      <div className={css(AppStyles.containerNarrow, Styles.containerNarrow)}>
        <Slider {...settingSlider} className={css(Styles.slider)}>
          {this.state.items.length > 0 &&
            this.state.items.map((option, index) => {
              return (
                <div className={css(Styles.sliderOuterContent)} key={option.id}>
                  <div className={css(Styles.sliderContent)}>
                    <h2 className={css(Styles.headerContent)}>{option.title}</h2>
                    <p className={css(Styles.descContent)}>{option.descr}</p>
                  </div>
                  {index === this.state.items.length - 1 &&
                  <Link to={this.getHomeLink()} className={css(CommonStyles.link)}>
                    <ButtonComponent
                      label='LET’S DO IT'
                    />
                  </Link>
                  }
                </div>
              )
            })}
        </Slider>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  containerNarrow: {
    height: 'unset',
    minHeight: '75vh',
    maxWidth: '95%',
    '@media (max-width: 768px)': {
      maxWidth: '100%',
      minHeight: '70vh',
    },
  },
  slider: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 0,
    '@media (max-width: 767px)': {
      display: 'unset',
      flex: 0,
      bottom: 0,
    },
  },
  sliderContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    outline: 'none',
    '@media (max-width: 767px)': {
      margin: 0
    },
  },
  sliderOuterContent: {
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  sliderContent: {
    //width: '100%',
    minHeight: 350,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'column',
    '@media (max-width: 767px)': {
      width: '100%',
      minHeight: 200,
    },
    '@media(min-width: 768px) and (max-width: 1024px)': {
      //width: '100%',
      minHeight: 300,
    },
  },
  headerContent: {
    textAlign: 'left',
    fontSize: 35,
    fontWeight: 'normal',
    margin: AppTheme.pMargin,
    marginBottom: 20,
    marginLeft: '20px',
    marginRight: '20px',
    '@media (max-width: 767px)': {
      fontSize: 18,
      margin: 10,
    }
  },
  descContent: {
    fontSize: 16,
    whiteSpace: 'pre-wrap',
    maxWidth: 950,
    textAlign: 'start',
    margin: '10px 20px',
    '@media (max-width: 767px)': {
      fontSize: 12,
      margin: 10,
      //textAlign: 'center',
    }
  },
  iconContent: {
    color: AppTheme.primaryColor,
    fontSize: 60,
    fontWeight: 'bolder',
    cursor: 'pointer',
    '@media (max-width: 767px)': {
      fontSize: 40,
    }
  },
  dotContent: {
    margin: 0,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
  }
})



// WEBPACK FOOTER //
// ./src/screens/Introduction.js